import { Pagination, useListContext } from "react-admin"
import { Box, Typography } from "@mui/material"

export const CustomPagination = () => {
  const { data } = useListContext()
  return (
    <Box display="flex" alignItems="center" width="100%">
      <Typography variant="body2">Unique KOLs: {data?.[0]?.uniqueRecord || 0}</Typography>

      <Box sx={{ ml: 2, mr: 0 }}>|</Box>

      <Pagination />
    </Box>
  )
}
